import { motion, AnimatePresence } from 'framer-motion';

export const ChatTeaserBubble = ({ visible, onClick }) => (
  <AnimatePresence>
    {visible && (
      <motion.div
        initial={{ opacity: 0, y: 10, scale: 0.9 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 10, scale: 0.9 }}
        className="fixed bottom-[100px] right-6 z-50 cursor-pointer"
        onClick={onClick}
      >
        <div className="relative bg-white text-gray-800 px-5 py-3 rounded-2xl shadow-xl">
          <p className="text-[15px] font-medium whitespace-nowrap">Hi, how can I help?</p>
          <div
            className="absolute -bottom-[10px] right-5 w-0 h-0"
            style={{
              borderLeft: '10px solid transparent',
              borderRight: '10px solid transparent',
              borderTop: '12px solid white',
            }}
          />
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);
